import clsx from "clsx";
import { HTMLAttributes, ReactNode } from "react";

interface Props extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  className?: string;
  backgroundColor?: "white" | "gray";
}

const Box = ({
  children,
  className,
  backgroundColor = "white",
  ...rest
}: Props) => {
  return (
    <div
      className={clsx(
        "py-[1.063rem] px-[1.875rem] rounded-md border border-gray",
        backgroundColor === "white" ? "bg-white" : "bg-lightGray",
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Box;
